
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { colorList } from '@/utils/colorList';
@Component
export default class extends Vue {
  @Prop() editCards!: any;
  @Prop() dialogVisible!: Boolean;
  @Prop() titleVaule!: String;
  rules = {
    title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
    price: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
    amount: [
      // { required: true, message: '请输入时长', trigger: 'blur' },
      { required: true, validator: this.getTime, trigger: 'blur' },
    ],
    price_desc: [{ required: true, message: '请输入补充说明', trigger: 'blur' }],
    pay_desc: [{ required: true, message: '请输入支付说明', trigger: 'blur' }],
    valid_days: [{ required: true, message: '请输入有效期', trigger: 'blur' }],
    color: [{ required: true, message: '请选择背景色', trigger: 'blur' }],
  };
  checkColorIndex: number = 0;
  checkColorItem: string = '';
  colorList: object[] = colorList;

  @Emit('handleClose')
  handleClose(formName: any) {
    (this.$refs[formName] as Form).resetFields();
  }

  getTime(rule: any, value: any, callback: any) {
    //  console.log('111', value);
    // console.log(new RegExp('[1-9][0-9]*(\.[0-9]*[1-9])?|0\.[0-9]*[1-9]').test(value));
    let newValue: number = 0;
    if (!value) {
      // this.editCards.amount = -1;
      return callback();
    } else {
      if (new RegExp('[1-9][0-9]*(\.[0-9]*[1-9])?|0\.[0-9]*[1-9]').test(value)) {
        newValue = JSON.parse(value);
        if (newValue < 0) {
          return callback(new Error('时长应为大于0的数字,不填为无限时长'));
        }
        // if (newValue > 999) {
        //   return callback(new Error('时长应为小于999的数字,不填为无限时长'));
        // }
        return callback();
      } else {
        return callback(new Error('时长应为大于0少于999的数字,不填为无限时长'));
      }
    }
  }
  // @Emit('editSure')
  editSure(formName: any) {
    // return this.editCards;
    (this.$refs[formName] as Form).validate((valid: boolean) => {
      if (valid) {
        // 周期卡时长不填, 则默认为无限时长卡, amount字段传-1
        if (!this.editCards.amount) {
          this.editCards.amount = -1;
        }
        this.$emit('editSure', this.editCards);
      } else {
        //  console.log('error submit!!');
        return false;
      }
    });
  }
  change(e: any) {
    this.$forceUpdate();
  }
  handleCheck(item: any) {
    this.editCards.color = item;
  }
  mounted() {}
}
